module.exports = __webpack_public_path__ + "static/media/user.82e1deb8.png";